import { render, staticRenderFns } from "./BaseSlidePanel.vue?vue&type=template&id=3e5fdc68&scoped=true"
import script from "./BaseSlidePanel.vue?vue&type=script&lang=js"
export * from "./BaseSlidePanel.vue?vue&type=script&lang=js"
import style0 from "./BaseSlidePanel.vue?vue&type=style&index=0&id=3e5fdc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5fdc68",
  null
  
)

export default component.exports